var MDB = window.MDB || {};
MDB.DPN = MDB.DPN || {};
MDB.DPN.Campaigns = MDB.DPN.Campaigns || {};
MDB.DPN.Campaigns.Advanced = MDB.DPN.Campaigns.Advanced || {};

(function() {
    var _id,
    _businessCaseSettingsId,
    _channelSettingsId,
    _sourceChannels,
    _followupChannels,
    _followupValue,
    _sourceValue;

	var _state = {
	    conceptCampaign: 0,
	    activeCampaign: 1
	};

    var _editorState,
    _config;
    
    var _testSpecificationsGrid,
    _selectionsGrid,
    _businessCaseSourceSpecificationsGrid,
    _channelSettingsInboundGrid,
    _requestGrid;

    $.extend(MDB.DPN.Campaigns.Advanced, {
    	boot: function (config) {
            _id = $('#Id').val();
            _businessCaseSettingsId = $('#business-case-settings [name$="Id"]').val();
            _channelSettingsId = $('#channel-settings [name$="Id"]').val();

            _config = config;
            _editorState = MDB.DPN.Campaigns.Editor.states();

            MDB.bootKendoMultiSelects();

            initAdvancedEditor();
            
            MDB.initBootstrapSwitchesDependantControls($('.enable-switch'));
            $('.init-hidden').show();

            appendIframeModal();

            $(document).ready(function () {
                $('#edit-campaign-form').data('validator').settings.ignore = "";
            });    
    	},
        addPremium: function(button) {
            button = $(button);
            
            var container = button.closest('#new-premium-container');
            var textbox = container.find('#new-premium');
            textbox.val('');
        },
        offerRequestClick: function(button) {
             //e.preventDefault();

            //Need to get this somewhere else
            var row = button.closest('tr');
            var model = MDB.KendoConfigBuilder.findGridRowModel(row);
            
            var url = model.Url + model.Id;
            var win = window.open(url, '_blank');
            win.focus();
        },

    });

    function initAdvancedEditor() {
        MDB.DPN.Campaigns.Editor.init(_config.editorTypes);
        addButtonHandlers();
        initGrids();
        initNumericInput();

        _sourceChannels = $('#Channels');
        _followupChannels = $('#FollowupChannels');

        initChannelCreator();
    }

    function submitFormAjax(form, successMessage, alternateUrl) {
        var def = $.Deferred();
        var url = alternateUrl || form.attr('action');

        MDB.sendAjaxRequest(url, form.serializeToJSON({associativeArrays: false}), form.attr('method')).done(function (response) {
            if(response.errors && response.errors.length > 0) {
                MDB.Notify.bootstrapDanger(errors.join('<br />'));
                def.reject();
            } else {
                if(response.success) {
                    if(successMessage !== undefined) {
                        MDB.Notify.bootstrapSuccess(successMessage);
                    }
                    def.resolve(response);
                }
            }
        });

        return def.promise();
    }

    function addButtonHandlers() {
        var form = $('#advanced-campaign').find('form');

        form.find('#add-selection').click(function (e) { 
            addSelectionClick(e); 
        });
        form.find('#add-premium').click(function (e) { 
            addPremiumClick(e); 
        });
        form.find('#add-title-division').click(function (e) { 
            titleDivisionClick(e); 
        });
        form.find('#add-product-division').click(function (e) { 
            productDivisionClick(e); 
        });
        form.find('#add-source-specification').click(function (e) { 
            sourceSpecificationClick(e); 
        });
        form.find('#add-test-specification').click(function (e) { 
            testSpecificationClick(e); 
        });
        form.find('#add-inbound').click(function (e) { 
            inboundClick(e, form); 
        });
        form.find('#new-offer-request').click(function (e) { 
            newOfferRequestClick(e, form); 
        });
        form.find('[data-action="all-titles"]').click(function (e) { 
            allTitlesClick(e, form) ;
        });
        form.find('[data-action="campaign-save"]').click(function (e) { 
            saveCampaignClick(e, _state.activeCampaign, form); 
        });
        form.find('[data-action="campaign-concept"]').click(function (e) {
             saveCampaignClick(e, _state.conceptCampaign, form);
        });
        form.find('[data-action="campaign-save-back"]').click(function (e) { 
            saveCampaignClick(e, _state.conceptCampaign, form); 
        });
        form.find('[data-action="campaign-save-stay"]').click(function (e) { 
            saveCampaignClick(e, _state.conceptCampaign, form, true); 
        });
        form.find('[data-action="back"]').click(function (e) { 
            e.preventDefault(); window.location.href = _config.backUrl; 
        });

        //Handlers also used in (reloaded) components
        form.on('click', '[data-action="select-atl"]', function (e) {
            selectTypeChannelsClick(e, 'atl') ;
        });
        form.on('click', '[data-action="select-btl"]', function (e) {
            selectTypeChannelsClick(e, 'btl') ;
        });
    }

    //**********Button click event handlers**********

    function saveCampaignClick(e, state, form, stayOnPage) {
        e.preventDefault();

        state = state || 0;
        form.find('#State').val(state);

        if(state == _state.activeCampaign) {
                MDB.promptWithIcon(
                    MDB.loadResourceString('Campaigns_Save_Campaign_Prompt_Title'), 
                    MDB.loadResourceString('Campaigns_Save_Campaign_Prompt_Body'), 
                    'fa fa-exclamation-triangle text-warning',
                    function(ok) {
                        if(ok) {
                            save(state, form, stayOnPage);
                        }
                    }
                );
        } else {
            save(state, form, stayOnPage);
        }
    }

    function save(state, form, stayOnPage) {
        if(form.valid()) {

            MDB.sendAjaxRequest(
            form.attr('action').split('?')[0] + '?stayOnPage=true',
                //MVC does not handle associative arrays very well
                form.serializeToJSON({associativeArrays: false}),
                form.attr('method')
            )
            .done(function (response) {
                MDB.Notify.bootstrapSuccess(MDB.loadResourceString('Dpn_Campaigns_Saved_Successfully_Text'));

                //Even though we're not staying on the page; only part of the model is actually submitted
                //this can cause a fair hassle once our model is not actually valid due to it being incomplete
                //which either forces a model refresh; or attempt to display an invalid model (which causes the page to crash)
                if(!stayOnPage){
                    //Give some time for notification to appear
                    //Redirecting will take some time either way
                    //So don't wait for too long
                    setTimeout(function(){
                        window.location = _config.backUrl;
                    }, 500);
                }
            });
        } else {
            var errors = _.map(form.validate().errorList, function (item) {
                return item.message;
            });

            MDB.Notify.bootstrapDanger(errors.join('<br />'));
        }
    }

    function allTitlesClick(e, selector) {
        e.preventDefault();
        var listbox = selector.find("#Titles").data('kendoMultiSelect');
        MDB.DPN.Campaigns.Editor.kendoListBoxSelectAll(listbox);
    }
    function selectTypeChannelsClick(e, type) {
        e.preventDefault();
        
        //Element type needs to be specified; kendo widget inherits original control's class
        var target = $(e.target)
            .closest('.channels-container')
            .find('select.channels-selector');
        
        var listbox = target.data('kendoMultiSelect');
        MDB.DPN.Campaigns.Editor.kendoListBoxSelectTypeChannels(listbox, type);
        
        //Don't update channel lists when the channel settings themselves are updated
        if(!target.closest('#channel-settings').length){
            updateChannelList(true);
            updateChannelSettings(true);   
        }
    }
    

    function addSelectionClick(e) {
        e.preventDefault();
        var url = MDB.DPN.Campaigns.Editor.buildEditorUrl(_config.getEditor,
            MDB.DPN.Campaigns.Editor.type('CampaignSelectionModel'), _editorState.create, _id, [{name: 'id', value: _id}]);

        MDB.DPN.Campaigns.Editor.load('<i class="fa fa-plus text-success"></i> ' + MDB.loadResourceString('Campaigns_Advanced_Selection_Title'), url, null, function (form) { 
            submitFormAjax(form, MDB.loadResourceString('Campaigns_Advanced_Selection_Success_Message')).done(function(){
                MDB.KendoConfigBuilder.reloadGrid(_selectionsGrid);
            });
        });
    }

    function addPremiumClick(e) {
         e.preventDefault();

        var url = MDB.DPN.Campaigns.Editor.buildEditorUrl(_config.getEditor, 
            MDB.DPN.Campaigns.Editor.type('CampaignPremiumModel'), _editorState.create, _id);

        MDB.DPN.Campaigns.Editor.load('<i class="fa fa-plus text-success"></i> ' + MDB.loadResourceString('Campaigns_Advanced_Premium_Title'), url, null, function (form) { 
            
            submitFormAjax(form, MDB.loadResourceString('Campaigns_Advanced_Premium_Success_Message')).done(function (response) {
               
               var kendoListbox = $('#PropositionSettings_Premiums').data("kendoMultiSelect");
                
                kendoListbox.dataSource.add({
                    text: response.value.Name,
                    value: response.value.Id
                });

                var values = kendoListbox.value();
                values.push(response.value.Id);
                kendoListbox.value(values);
            });
        });
    }

    function newOfferRequestClick(e, form) {
        e.preventDefault();
    
        var iframe = $('#offerFrame');     
        var modal = $('#iframe-modal');
        var spinner = modal.find('.fa-spinner');

        iframe.hide();
        spinner.show();
        modal.modal('show');

        submitFormAjax(form, undefined, _config.createOfferRequest).done(function (response) {
            if(response.success) {
                MDB.KendoConfigBuilder.reloadGrid(_requestGrid);         
                iframe.attr('src', response.value.ReturnUrl + response.value.Id);
            }
        });
    }

    function appendIframeModal() {
        var template = $(([
            '<div class="modal fade" id="iframe-modal" tabindex="-1" role="dialog" aria-labelledby="iframeModal" aria-hidden="true">',
                '<div class="modal-dialog modal-full-width modal-dialog-centered" role="document">',
                    '<div class="modal-content">',
                        '<div class="modal-header">',
                            '<h4 class="modal-title">',
                                '<i class="fa fa-plus text-success"></i> ',
                                MDB.loadResourceString('Campaigns_Advanced_Offer_Request_Title'),
                            '</h4>',
                            '<button type="button" class="close" data-dismiss="modal" aria-label="Close">',
                                '<span aria-hidden="true">×</span>',
                            '</button>',
                        '</div>',
                        '<div class="modal-body">',
                            '<div id="iframe-modal-body">',
                                '<i class="iframe-modal-spinner text-primary fas fa-spinner fa-spin fa-3x" style="display:none;"></i>',
                                '<iframe id="offerFrame" style="display:none;"></iframe>',
                            '</div>',
                        '</div>',
                    '<div class="modal-footer">',
                        '<button class="btn btn-danger" id="editor-cancel-btn" data-dismiss="modal">',
                            '<i class="fa fa-ban"></i> ' + MDB.loadResourceString('Button_Back'),
                        '</button>',
                    '</div>',
                '</div>',
            '</div>',
        ' </div>'].join('')));

        var body = $('body');
        var modal = body.append(template);
        var iframe = body.find('#offerFrame');

        iframe.on('load', function () {
            if(iframe.attr('src') !== undefined) {
                
                var modal = $('#iframe-modal');
                var spinner = modal.find('.fa-spinner');
                
                cleanIframeUi(iframe);
                spinner.hide();
            }
        });
        
        return modal;
    }

    //Ugly as sin. But the customer is king.
    function cleanIframeUi(iframe) {
        var html = iframe.contents().find('html');
        var content = html.find('body');

        html.css('min-height', 0);

        //Remove unwanted elements.
        content.find('.content-header,.main-header,.main-sidebar,.error-container,#offers-menu').remove();
        
        //Overflow hidden to hide iframe horizontal scroll.
        content.css('overflow-x', 'hidden');
        content.css('min-height', 0);

        //Remove margins and min height
        var rightSide = content.find('.right-side');
        rightSide.css('margin-top', 0);
        rightSide.css('margin-left', 0);
        rightSide.css('min-height', 0);

        //**********DPN Specific css*********

        //Checkboxes are posisioned weirdly now. Fix.
        var newSite = content.find('#new-site');
        var urgency = content.find('#urgency');

        newSite.removeClass('col-xs-offset-4');

        //Checkbox container width to auto.
        var newSiteColumns = newSite.find('.col-xs-2,.col-xs-10');
        newSiteColumns.removeClass('col-xs-2');
        newSiteColumns.removeClass('col-xs-10');
        newSiteColumns.addClass('col-auto');

        var urgencyColumns = urgency.find('.col-xs-2,.col-xs-10');
        urgencyColumns.removeClass('col-xs-2');
        urgencyColumns.removeClass('col-xs-10');
        urgencyColumns.addClass('col-auto');

        //make all rows use full container with.
        var nonFullWithColumns = content.find('.col-xs-4,.col-xs-8');
        nonFullWithColumns.removeClass('col-xs-4');
        nonFullWithColumns.removeClass('col-xs-8');
        nonFullWithColumns.addClass('col-xs-12');
        
        iframe.show();
    }

    function titleDivisionClick(e) {
        e.preventDefault();

        var url = MDB.DPN.Campaigns.Editor.buildEditorUrl(_config.getEditor, 
            MDB.DPN.Campaigns.Editor.type('CampaignProductDivisionModel'), _editorState.edit, _id, [{name: 'id', value: _businessCaseSettingsId}]);

        MDB.DPN.Campaigns.Editor.load('<i class="fa fa-plus text-success"></i> ' + MDB.loadResourceString('Campaigns_Advanced_Title_Division_Title'), url, initSliders, function (form) { 
            submitFormAjax(form, MDB.loadResourceString('Campaigns_Advanced_Title_Division_Success_Message'));
        });
    }

    function productDivisionClick(e) {
        e.preventDefault();
        
        var url = MDB.DPN.Campaigns.Editor.buildEditorUrl(_config.getEditor, 
            MDB.DPN.Campaigns.Editor.type('CampaignProductTypeDivisionModel'), _editorState.edit, _id, [{name: 'id', value: _businessCaseSettingsId}]);

        MDB.DPN.Campaigns.Editor.load('<i class="fa fa-plus text-success"></i> ' + MDB.loadResourceString('Campaigns_Advanced_Product_Division_Title'), url, initSliders, function (form) {
            submitFormAjax(form, MDB.loadResourceString('Campaigns_Advanced_Product_Division_Success_Message'));
        });
    }

    function sourceSpecificationClick(e) {
        e.preventDefault();

        var url = MDB.DPN.Campaigns.Editor.buildEditorUrl(_config.getEditor,
            MDB.DPN.Campaigns.Editor.type('CampaignBusinessCaseSourceSpecifications'), _editorState.create, _id, [{name: 'id', value: _businessCaseSettingsId}]);

        MDB.DPN.Campaigns.Editor.load('<i class="fa fa-plus text-success"></i> ' + MDB.loadResourceString('Campaigns_Advanced_Source_Spec_Title'), url, null, function (form) { 
            submitFormAjax(form, MDB.loadResourceString('Campaigns_Advanced_Source_Spec_Success_Message')).done(function(){
                MDB.KendoConfigBuilder.reloadGrid(_businessCaseSourceSpecificationsGrid);
            });
        });
    }

    function testSpecificationClick(e) {
        e.preventDefault();

        var url = MDB.DPN.Campaigns.Editor.buildEditorUrl(_config.getEditor,
            MDB.DPN.Campaigns.Editor.type('CampaignTestSpecifications'), _editorState.create, _id);

        MDB.DPN.Campaigns.Editor.load('<i class="fa fa-plus text-success"></i> ' + MDB.loadResourceString('Campaigns_Advanced_Test_Spec_Title'), url, null, function (form) { 
            submitFormAjax(form, MDB.loadResourceString('Campaigns_Advanced_Test_Spec_Success_Message')).done(function(){
                MDB.KendoConfigBuilder.reloadGrid(_testSpecificationsGrid);
            });
        });
    }

    function inboundClick(e) {
        e.preventDefault();

        var url = MDB.DPN.Campaigns.Editor.buildEditorUrl(_config.getEditor,
            MDB.DPN.Campaigns.Editor.type('CampaignChannelInbound'), _editorState.create, _id, [{name: 'id', value: _channelSettingsId}]);

        MDB.DPN.Campaigns.Editor.load('<i class="fa fa-plus text-success"></i> ' + MDB.loadResourceString('Campaigns_Advanced_Inbound_Title'), url, null, function (form) { 
            submitFormAjax(form, MDB.loadResourceString('Campaigns_Advanced_Inbound_Success_Message')).done(function(){
                MDB.KendoConfigBuilder.reloadGrid(_channelSettingsInboundGrid);
            });
        });
    }

    ///**********GRIDS**********

    function initGrids() {
        _selectionsGrid = MDB.DPN.Campaigns.initSelectionsGrid($('#selections-grid'), _config.selectionsUrl + _id);
        _businessCaseSourceSpecificationsGrid = MDB.DPN.Campaigns.initSourceSpecificationsGrid($('#source-specifications-grid'), _config.sourcesUrl + _id);
        _testSpecificationsGrid = MDB.DPN.Campaigns.initTestSpecificationsGrid($('#test-specifications-grid'), _config.testsUrl + _id);
        _channelSettingsInboundGrid = MDB.DPN.Campaigns.initInboundGrid($('#inbound-grid'), _config.inboundUrl + _id);
        
        _requestGrid = MDB.DPN.Campaigns.initRequestGrid($('#offer-requests-grid'), _config.requestUrl + _id, _config.hasAccessToOfferRequests);
        _requestGrid.data("kendoGrid").bind('dataBound', OfferRequestDataBound);

        MDB.DPN.Campaigns.initSourcesGrid($('#origins-grid'), _config.originsUrl + _id);
        MDB.DPN.Campaigns.initPropositionsGrid($('#propositions-grid'), _config.propositionsUrl + _id);

    }

    ///**********SPECIAL CONTROLS**********

    function OfferRequestDataBound(e) {
        var buttons = _requestGrid.find('[data-action="offer-request"]');

        if(!_config.hasAccessToOfferRequests) {
            buttons.css('cursor', 'default');
            buttons.attr('onclick', '');
            buttons.css('color', '#cbcbcb');
            buttons.removeClass('mdb-icon-btn-primary');

            buttons.each(function () {
                var button = $(this);
                MDB.DPN.Campaigns.loadTooltip(button, 
                    MDB.loadResourceString('CampaignPropositionSettings_OfferRequest_Disabled_Tooltip'));
            });
        } else {
            buttons.each(function () {
                var button = $(this);
                MDB.DPN.Campaigns.loadTooltip(button,
                    MDB.loadResourceString('CampaignPropositionSettings_OfferRequest_Tooltip'));
            });
        }
    }

    function initNumericInput(context){
        $(context || document).find('.campaign-numeric-field')
            .mdbNumericInput();
    }

    function initChannelCreator() {
        var source = _sourceChannels.data('kendoMultiSelect');
        var followup = _followupChannels.data('kendoMultiSelect');

        source.bind('dataBound', function () {
            _sourceValue = _sourceChannels.val() || [];
        });

        followup.bind('dataBound', function () {
            _followupValue = _followupChannels.val() || [];
        });

        source.bind('change', function () {
            updateChannelList(true);
        });
        followup.bind('change', function() {
            updateChannelList(false);
        });

        _sourceChannels.blur(function () {
            updateChannelSettings(true);
        });
        _followupChannels.blur(function () {
            updateChannelSettings(false);
        });

    }

    function updateChannelList(source) {

        var old = source ? _sourceValue : _followupValue;
        var updated = source ? _sourceChannels.val() : _followupChannels.val();

        var newChannels = _.filter(updated, function (item) {
            if(old.indexOf(item) === -1) {
                return item;
            }
        });

        var deletedChannels = _.filter(old, function (item) {
            if(updated !== null && updated.indexOf(item) === -1) {
                return item;
            }
        });

        if(newChannels.length > 0) {
            newChannels.forEach(function (channel) {
                old.push(channel);
            });
        }

        if(deletedChannels.length > 0) {
            deletedChannels.forEach(function (channel) {
                old.splice(old.indexOf(channel), 1);
            });

            if(source) {
                _sourceChannels.data("kendoMultiSelect").focus();
            } else {
                _followupChannels.data("kendoMultiSelect").focus();
            }
        }
    }

    function updateChannelSettings(source) {
        var channelSettings = $('#channel-settings');
            var form = $('<form />').append($('#channel-settings').parent().clone());
            
            var settings = 
            form.serializeToJSON({associativeArrays: false}).ChannelSettings || 
            { 
                Settings: []
            };

            settings.CampaignId = _id;

            MDB.sendAjaxRequest(_config.updateChannelSettingsUrl,
                {
                    settings: settings,
                    sourceChannels: _sourceValue,
                    followupChannels: _followupValue
                }, 'POST'
            ).done(function (response) {
                //We only actually update the channel settings editors
                //Easiest way to extract the inner HTML
                var responseSettingsEditors = $('<div />')
                    .append(response)
                    .find('.channel-settings-editors')
                    .html();
                
                var settingsEditors = channelSettings
                    .find('.channel-settings-editors');

                settingsEditors
                    .html(responseSettingsEditors);
                
                MDB.initKendoDropdownLists(settingsEditors);
                MDB.initKendoMultiSelects(settingsEditors);
                MDB.initMdbFileUploads(settingsEditors);
                MDB.initKendoDatePickers(settingsEditors);
            });
    }
    
    function initSliders(context){
        //MDB.EmailCampaign.loadManualSettingsSliders
        
        //All controls should be updated in one swoop
        function updateValues(el, data){
            var row = $(el).closest('.percentage-slider-row'),
                step = row.data('step'),
                slider = row.find('.percentage-slider'),
                percentageInput = row.find('.slider-percentage'),
                countInput = row.find('.slider-count');

            //Either a rawValue, or a percentage is provided depending on the caller
            if(data.rawValue) {
                data.percentage = (data.rawValue / step).toFixed(2);
            } else {
                data.rawValue = data.percentage * step;
            }

            slider.data('slider').setValue(data.percentage);
            percentageInput.val(data.percentage);
            countInput.val(data.rawValue);
        }
        
        function updatePercentage(el){
            var me = $(el);

            updateValues(el, {
                percentage: me.val()
            });
        }
        
        function updateRawValue(el){
            var me = $(el);

            updateValues(el, {
                rawValue: me.val()
            });
        }

        function resetValues(el) {

            var button = $(el),
            row = button.closest('.row'),
            count = row.find('.slider-count'),
            percentage = row.find('.slider-percentage'),
            slider = row.find('.percentage-slider');

            count.val(count.attr('value'));
            percentage.val(percentage.attr('value'));
            slider.data('slider').setValue(slider.data('slider-value'));
        }
        
        //Change handler HAS to be attached before initiating slider
        //Slider contains a bug where it returns undefined when the selector is empty 
        context.find('.percentage-slider').on('change', function(){
            updatePercentage(this);
        }).slider({
            formatter: function(value){
                return 'Current value: ' + value;
            }
        });
        
        context.find('.slider-percentage').on('mouseup', function(){
            updatePercentage(this);
        });

        context.find('.slider-percentage').on('keyup', function(){
            updatePercentage(this);
        });

        context.find('.slider-count').on('mouseup', function(){
            updateRawValue(this);
        });

        context.find('.slider-count').on('keyup', function(){
            updateRawValue(this);
        });

        context.find('.manual-reset-btn').on('click', function () {
            resetValues(this);
        });

        // function triggerAllSliders(name, percentage) {
        //     if(name == MDB.loadResourceString('Dpn_EmailCampaign_ManualSettings_All_DisplayName')) {
        //         $('.percentage-slider').each(function () {
        //             var thisSlider = $(this);
        //             thisSlider.slider('setValue', parseFloat(percentage));
        //             var sliderName = thisSlider.attr('id').split('-')[0];
        //             var currentMax =  $('#' + sliderName + '-max').val();

        //             $('#' + sliderName + '-percentage').val(thisSlider.val());
        //             $('#' + sliderName + '-count').val(Math.ceil(currentMax / 100 * parseFloat(thisSlider.val())));
        //         });
        //     }
        // }
    }
})();
